/* kaufweise Laenderhinweis: liest das per IP erkannte Land vom nativen Shopify-Endpunkt
   /browsing_context_suggestions.json und zeigt bei Bedarf den Balken aus
   snippets/kw-market-hint.liquid. Kein Redirect ohne Klick (siehe PLAN-markets-weiche.md).
   Haengt von assets/kw-market-hint-resolve.js ab (muss vorher geladen sein, kein Modul,
   kein Bundler, keine externe Abhaengigkeit). */
(function () {
  "use strict";

  var COOKIE_NAME = "kw_market_hint";
  var COOKIE_DAYS = 180;
  var FETCH_TIMEOUT_MS = 5000;

  function isBot() {
    if (navigator.webdriver) return true;
    var ua = (navigator.userAgent || "").toLowerCase();
    return /bot|crawl|spider|slurp|preview|headless/.test(ua);
  }

  function readCookie(name) {
    var match = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, "\\$1") + "=([^;]*)"));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + expires + "; path=/; SameSite=Lax";
  }

  function withTimeout(promise, ms) {
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { reject(new Error("timeout")); }, ms);
      promise.then(function (v) { clearTimeout(timer); resolve(v); },
        function (e) { clearTimeout(timer); reject(e); });
    });
  }

  function labelFor(options, code) {
    if (!options || !code) return code;
    // Shopify liefert options als Objekt { "DE": "Deutschland", ... } (gemessen 05.09.2026)
    if (!Array.isArray(options) && typeof options === "object") {
      var direct = options[String(code).toUpperCase()];
      return direct ? direct : code;
    }
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      var value = opt && (opt.value || opt.code || opt.handle);
      if (value && String(value).toUpperCase() === String(code).toUpperCase()) {
        return opt.label || opt.name || value;
      }
    }
    return code;
  }

  function buildTargetUrl(target) {
    var path = (window.location.pathname || "/").replace(/^\/+/, "/");
    var prefix = target.pathPrefix || "";
    var search = window.location.search || "";
    if (prefix && path === "/") {
      return "https://" + target.host + prefix + "/" + search;
    }
    return "https://" + target.host + prefix + path + search;
  }

  function showBar(container, opts) {
    // headline ist bereits serverseitig fertig (shop_country kommt aus localization.country.name,
    // siehe snippets/kw-market-hint.liquid), hier nur Uebernahme ins sichtbare Element.
    var headlineEl = container.querySelector("[data-kw-mh-headline]");
    var textEl = container.querySelector("[data-kw-mh-text]");
    var switchEl = container.querySelector("[data-kw-mh-switch]");
    if (headlineEl) {
      headlineEl.textContent = headlineEl.getAttribute("data-template")
        .replace("{{ shop_country }}", opts.shopCountry || "");
    }
    if (textEl) {
      textEl.textContent = textEl.getAttribute("data-template")
        .replace("{{ country }}", opts.country)
        .replace("{{ host }}", opts.host);
    }
    if (switchEl) {
      switchEl.textContent = switchEl.getAttribute("data-template").replace("{{ host }}", opts.host);
      switchEl.setAttribute("href", opts.targetUrl);
      switchEl.addEventListener("click", function () {
        writeCookie(COOKIE_NAME, "switched", COOKIE_DAYS);
      });
    }
    container.hidden = false;
    // kein requestAnimationFrame: in Hintergrund-Tabs feuert es nicht, der Balken bliebe unsichtbar
    setTimeout(function () { container.classList.add("kw-market-hint--visible"); }, 30);
  }

  function init() {
    var container = document.getElementById("kw-market-hint");
    if (!container) return;
    if (isBot()) return;
    if (readCookie(COOKIE_NAME)) return;

    var dismissEl = container.querySelector("[data-kw-mh-dismiss]");
    var closeEl = container.querySelector("[data-kw-mh-close]");
    function dismiss() {
      writeCookie(COOKIE_NAME, "dismissed", COOKIE_DAYS);
      if (container.parentNode) container.parentNode.removeChild(container);
    }
    if (dismissEl) dismissEl.addEventListener("click", dismiss);
    if (closeEl) closeEl.addEventListener("click", dismiss);

    if (!window.KwMarketHint || typeof window.KwMarketHint.resolveTarget !== "function") return;

    var acceptLanguagePrimary = (navigator.language || "en").slice(0, 2).toLowerCase();
    var endpoint = "/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true";

    withTimeout(fetch(endpoint, { credentials: "same-origin" }), FETCH_TIMEOUT_MS)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || !data.detected_values || !data.detected_values.country) return;
        var detectedCountry = data.detected_values.country.handle;
        var target = window.KwMarketHint.resolveTarget(window.location.hostname, detectedCountry, acceptLanguagePrimary);
        if (!target) return;

        var options = (data.suggestions && data.suggestions[0] && data.suggestions[0].parts &&
          data.suggestions[0].parts.country && data.suggestions[0].parts.country.options) || [];
        // Namen in der Seitensprache (aus Liquid localization.available_countries) haben Vorrang
        try {
          var codes = JSON.parse(container.getAttribute("data-country-codes") || "[]");
          var names = JSON.parse(container.getAttribute("data-country-names") || "[]");
          if (codes.length && codes.length === names.length) {
            var pageNames = {};
            for (var ci = 0; ci < codes.length; ci++) pageNames[String(codes[ci]).toUpperCase()] = names[ci];
            options = pageNames;
          }
        } catch (e) { /* Endpunkt-Namen als Fallback */ }
        var ownCountry = "";
        var markets = window.KwMarketHint.MARKETS || {};
        var here = String(window.location.hostname || "").toLowerCase().replace(/^www\./, "");
        for (var mk in markets) {
          if (markets[mk].host === here) { ownCountry = markets[mk].ownCountry; break; }
        }
        showBar(container, {
          shopCountry: ownCountry ? labelFor(options, ownCountry) : "",
          country: labelFor(options, detectedCountry),
          host: target.host,
          targetUrl: buildTargetUrl(target)
        });
      })
      .catch(function () { /* jede Fehlerlage still, kein Hinweis */ });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
